export const baseQueryConfig = {
  // refetchOnMount: false,
  // refetchOnWindowFocus: false,
  // refetchOnReconnect: false,
};

export const EXTERNAL_LINKS_EN = {
  trackTransaction: 'https://www.westernunion.com/web/global-service/track-transfer',
  findLocation:
    'https://www.westernunion.com/global-services/find-locations?WUCountry=rs&WULanguage=en',
  findLocationForVerification: 'https://www.tenfore.rs/en/locations/list/wu-identification',
  customerSupport: 'https://www.tenfore.rs/en/for-customers/contact',
};

export const EXTERNAL_LINKS_SR = {
  trackTransaction: 'https://www.westernunion.com/web/global-service/track-transfer?WULanguage=sr',
  findLocation:
    'https://www.westernunion.com/global-services/find-locations?WUCountry=rs&WULanguage=sr',
  findLocationForVerification: 'https://www.tenfore.rs/lokacije/lista/wu-identifikacija',
  customerSupport: 'https://www.tenfore.rs/za-korisnike/kontakt',
};

export const getExternalLinks = (lang: string) => {
  return lang === 'srb' ? EXTERNAL_LINKS_SR : EXTERNAL_LINKS_EN;
};
